import { toast } from "react-toastify";
const showToast = (message, type) => {
  if (message === 'Unauthenticated.') {
    window.location.href = 'login';
    return;
  }
  toast[type](message);
};

export default showToast;
